import React from 'react';
import { ListItem, ListItemText, Button, Icon } from '@mui/material';
import { get, uniqBy } from 'global/lib/lodash';
import { StyledAvatar, ListItemHeader, DatesText } from './TaskList.styles';
import moment from 'moment';

export default (props) => {
  const item = props.itemOverride || props.item;

  const clickDownload = (it) => {
    const url = get(it, 'full7DayUrl', get(it, 'fullUrl'));
    if (url) {
      window.open(url, '_blank');
    }
  };

  const content = {
    label: moment(get(item, 'createdAt')).format('dddd, MMMM DD, YYYY'),
    from: get(item, 'from.name', ''),
    to: get(item, 'users', []).map(u => u.name).join(', ') || 'N/A',
    media: uniqBy(get(item, 'media', []), 'customProperties.tradeType'),
  };
  content.icon = <Icon>description</Icon>;

  const renderMediaItem = (it, i) => {
    return (
      <div key={i}>
        <Button style={{ justifyContent: 'flex-start' }} size="small" onClick={() => clickDownload(it)} startIcon={<Icon>get_app</Icon>}>{get(it, 'customProperties.tradeType', 'ALL')}</Button>
      </div>
    )
  }

  return (
    <ListItem component={'div'} key={item.id}>
      <StyledAvatar>{content.icon}</StyledAvatar>
      <ListItemText
        primary={<ListItemHeader>{content.label}</ListItemHeader>}
        slotProps={{ secondary: { component: 'div' } }}
        secondary={
          <>
            <DatesText>{`From: ${content.from}`}</DatesText>
            <DatesText>{`To: ${content.to}`}</DatesText>
            {content.media.map(renderMediaItem)}
          </>
        }
      />
    </ListItem>
  );
};
